module.exports = __webpack_public_path__ + "static/media/oven.da13276e.svg";